import {
    HTTP
} from '@/utilities/http-common';

export default {
    namespaced: true,
    state: {
        count: 0
    },
    getters: {},
    mutations: {
        setCount(state, count) {
            state.count = count;
        },
        getCount(state) {
            return state.count;
        }
    },
    actions: {
        setNewCompoundCount({
            commit
        }, count) {
            commit('setCount', count);
        },
        getNewCompoundCount() {
            return HTTP.get('/kenya/new_compounds/get_count');
        }
    },
}